export default __webpack_public_path__ + "static/media/0013.c258ee86.svg";